var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"banner-dots"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,class:['banner-dot', { active: index === _vm.activeIndex }],on:{"click":function($event){$event.stopPropagation();return _vm.$emit('scroll-to', index)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }